module.exports = __webpack_public_path__ + "static/z16-2-0004-53e0c3698ebc330c298814ede7b3fcf8.jpg";